import { FC } from 'react'

import { isNotFoundError } from 'core/helpers/error'
import * as R from 'core/helpers/remeda'
import { useTeamGet } from 'core/types'

import ModelLink from './ModelLink'

type TeamLinkProps = {
  teamId: string
}

const TeamLink: FC<TeamLinkProps> = ({ teamId }) => {
  const { data: team, isLoading } = useTeamGet({
    teamId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  return <ModelLink id={teamId} isLoading={isLoading} model={team} />
}

export default TeamLink
